import { render, staticRenderFns } from "./BulkOrderStatus.vue?vue&type=template&id=510bf744&scoped=true&"
import script from "./BulkOrderStatus.vue?vue&type=script&lang=ts&"
export * from "./BulkOrderStatus.vue?vue&type=script&lang=ts&"
import style0 from "./BulkOrderStatus.vue?vue&type=style&index=0&id=510bf744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510bf744",
  null
  
)

export default component.exports